import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';

import YoutubeIcon from '../assets-2.0/youtube.svg';

const useStyles = makeStyles({
  text: {
    color: 'red',
    fontSize: 16,
    display: 'inline-block',
  },
  iconImage: {
    width: 20,
    height: 20,
    marginRight: 8,
  },
});

function YoutubeFlag(props) {
  const classes = useStyles();

  return (
    <Typography variant="h4" className={classes.text}>
      <img src={YoutubeIcon} className={classes.iconImage} alt="youtube icon" />
      Youtube
    </Typography>
  );
}

export default YoutubeFlag;
